import styled from 'styled-components';

const RuleBuilderItem = styled.div`
  padding: ${(props): string => props.theme.spaces.md};
  display: flex;
  align-items: center;
`;

export { RuleBuilderItem };
